import { doc, getDoc } from 'firebase/firestore'
import { db } from './firebase'

export const CERTIFICATE_VERIFY_GENERIC_FAILURE =
  'No matching certificate was found for the details you entered. Check the certificate ID, name, and completion date exactly as shown on the certificate.'

export function normalizeDisplayNameForVerification(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
}

function normalizeCertificateIdInput(raw) {
  return String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
}

/**
 * @param {{ certificateId: string, name: string, dateIso: string }} input dateIso = YYYY-MM-DD from date input
 * @returns {Promise<{ ok: true, record: object } | { ok: false, message: string }>}
 */
export async function verifyCertificatePublic({ certificateId, name, dateIso }) {
  const id = normalizeCertificateIdInput(certificateId)
  const iso = String(dateIso || '').trim().slice(0, 10)
  const nameNorm = normalizeDisplayNameForVerification(name)

  if (!id || !nameNorm || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    return { ok: false, message: CERTIFICATE_VERIFY_GENERIC_FAILURE }
  }

  try {
    const ref = doc(db, 'certificatePublicRecords', id)
    const snap = await getDoc(ref)
    if (!snap.exists()) {
      return { ok: false, message: CERTIFICATE_VERIFY_GENERIC_FAILURE }
    }
    const data = snap.data()
    const storedNorm = normalizeDisplayNameForVerification(data.displayNameNorm ?? data.displayName)
    const storedIso = String(data.completedDateIso || '').slice(0, 10)

    if (storedNorm !== nameNorm || storedIso !== iso) {
      return { ok: false, message: CERTIFICATE_VERIFY_GENERIC_FAILURE }
    }

    return {
      ok: true,
      record: {
        displayName: data.displayName || '',
        completedDateLabel: data.completedDateLabel || '',
        completedDateIso: storedIso,
        quizTitle: data.quizTitle || '',
        trackLabel: data.trackLabel || ''
      }
    }
  } catch (err) {
    console.error('certificate verify', err)
    return { ok: false, message: 'Verification could not be completed. Please try again later.' }
  }
}
